<template>
  <div class="table">
    <div class="join_property_btn">
      <div class="single flex">
        <span class="tit">常用报名项：</span>
        <div class="flex-1">
          <el-button
            @click="add(v)"
            plain
            size="small"
            style="marginBottom:10px"
            v-for="(v, i) in joinList"
            :key="i"
          >
            <i style="color:#E50065;">+</i> {{ v.columnName }}</el-button
          >
        </div>
      </div>
      <div class="single flex">
        <span class="tit">自定义报名项：</span>
        <div class="flex-1">
          <el-button
            @click="add(v, 'custom')"
            plain
            size="small"
            style="marginBottom:10px"
            v-for="(v, i) in customList"
            :key="i"
          >
            <i style="color:#E50065;">+</i> {{ v.columnName }}</el-button
          >
        </div>
      </div>
    </div>
    <div>
      <div class="table-header flex flex-nowrap">
        <div class="flex-1 text-center" style="flex: 0 0 230px;">报名项名称</div>
        <div class="flex-1 text-center">报名项限制</div>
        <div class="flex-1 text-center">是否必填</div>
        <div class="flex-1 text-center">是否可重复</div>
        <div class="flex-1 text-center">内容长度限制</div>
        <div class="flex-1 text-center">操作</div>
      </div>
      <div class="table-body">
        <draggable :list="list">
          <div
            class="flex table-row item-center"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="flex-1 text-start">
              <el-input
                class="ml10"
                size="small"
                clearable
                v-model="item.columnName"
              >
              </el-input>
              <div
                class="flex item-center ml10 mt10 zu"
                v-if="
                  item.columnType === 'radio' || item.columnType === 'checkbox'
                "
                v-for="(v, i) in item.paramInfoModels"
                :key="i"
              >
                <div
                  class="marker mr10"
                  v-if="item.columnType === 'radio'"
                ></div>
                <div
                  class="square mr10"
                  v-if="item.columnType === 'checkbox'"
                ></div>
                <el-input
                  style="width:260px"
                  size="small"
                  clearable
                  v-model="v.columnValue"
                  placeholder="输入选项"
                >
                </el-input>
                <div
                  class="minus-wrapper flex flex-center"
                  v-if="item.paramInfoModels.length > 2"
                >
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="delradio(index, i)"
                  ></span>
                </div>
              </div>
              <div
                class="mt10"
                style="marginLeft:35px"
                v-if="
                  item.columnType === 'radio' || item.columnType === 'checkbox'
                "
              >
                <el-button
                  plain
                  size="mini"
                  type="primary"
                  @click="addRadio(index)"
                >
                  添加选项</el-button
                >
              </div>
            </div>
            <div class="flex-1 text-center">
              <div v-if="item.columnType === 'text'">
                <div v-if="item.validRule === 'phone'">
                  手机号
                </div>
                <div v-else-if="item.validRule === 'number'">
                  数字
                </div>                
                <div v-else>
                  文本
                </div>
              </div>
              <div v-if="item.columnType === 'date'">
                日期
              </div>
              <div v-if="item.columnType === 'radio'">
                单选题
              </div>
              <div v-if="item.columnType === 'checkbox'">
                多选题
              </div>
              <div v-if="item.columnType === 'picture'">
                图片
              </div>
            </div>
            <div class="flex-1 text-center">
              <el-checkbox
                true-label="yes"
                false-label="no"
                v-model="item.columnMustInput"
                >必填</el-checkbox
              >
            </div>
            <div class="flex-1 text-center">
              <el-checkbox
                v-if="item.columnType === 'text'"
                true-label="no"
                false-label="yes"
                v-model="item.repeatedState"
                >不可重复</el-checkbox
              >
            </div>
            <div class="flex-1 text-center">
              <el-input
                v-if="item.columnType === 'text'"
                style="width:80px"
                type="number"
                class="ml10"
                size="small"
                clearable
                v-model.number="item.dataLength"
                placeholder="整数"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
              >
              </el-input>
            </div>
            <div class="flex-1 text-center">
              <el-button type="text" @click="deleteChild(index)"
                >删除</el-button
              >
            </div>
          </div>
        </draggable>
        <div
          class="el-table__empty-text flex flex-center"
          v-if="list.length === 0"
        >
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      show: true,
      customList: [
        {
          name: "单行文本",
          columnType: "inp",
          joinLimt: "inp"
        },
        {
          name: "单选题",
          columnType: "radio",
          joinLimt: "inp"
        },
        {
          name: "多选题",
          columnType: "checkbox",
          joinLimt: "inp"
        },
        {
          name: "图片",
          columnType: "picture",
          joinLimt: "inp"
        }
      ],
      joinList: [
        {
          name: "微信",
          columnType: "inp",
          joinLimt: "inp"
        },
        {
          name: "手机号",
          columnType: "inp",
          joinLimt: "inp"
        },
        {
          name: "年龄",
          columnType: "inp",
          joinLimt: "inp"
        }
      ],
      list: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryCommonItems();
  },
  methods: {
    async queryCommonItems() {
      const { result } = await this.$store.dispatch("queryCommonItems");
      const { commonItems, customList } = result;
      this.joinList = commonItems;
      this.customList = customList;
    },
    delradio(i, index) {
      this.list[i].paramInfoModels.splice(index, 1);
    },
    addRadio(i) {
      this.list[i].paramInfoModels.push({ name: "" });
    },
    deleteChild(index) {
      this.list.splice(index, 1);
    },
    add(v, type) {
      let row = JSON.parse(JSON.stringify(v));
      if (type === "custom") {
        row.columnName = "";
      }
      row.repeatedState = "yes";
      row.columnMustInput = "no";
      if (row.columnType === "radio" || row.columnType === "checkbox") {
        row.paramInfoModels = [{ columnValue: "" }, { columnValue: "" }];
      }
      this.list.push(row);
      this.list = [...this.list];
      //   this.rowDrop();
    },
    filterGt0OrFixed0(prop) {
      prop = prop.replace(/^(0+)/, ""); //过滤0开头
      prop = prop.replace(/[^\d]/g, "");
      prop = prop
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      prop = new Number(prop);
    },
    // rowDrop() {
    //   const tbody = document.querySelectorAll(
    //     ".el-table__body-wrapper > table > tbody"
    //   )[0];
    //   const _this = this;
    //   Sortable.create(tbody, {
    //     draggable: ".el-table__row",
    //     ghostClass: "sortable-ghost",
    //     onEnd({ newIndex, oldIndex }) {
    //       const currRow = _this.list.splice(oldIndex, 1)[0];
    //       _this.list.splice(newIndex, 0, currRow);
    //       _this.list = [..._this.list];
    //     }
    //   });
    // }
  }
};
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid #ebeef5;

  .el-table__empty-text {
    line-height: 60px;
    width: 100%;
    color: #909399;
    font-size: 12px;
  }
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
    border-bottom: 1px solid #ecf0f5;
  }
  .table-row:hover {
    cursor: move;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .join_property_btn {
    border-bottom: 1px solid #ecf0f5;
    background-color: #f9fafc;
    // height: 140px;
    position: relative;
  }
  .join_property_btn {
    overflow: hidden;
    padding-top: 25px;
  }
  .join_property_btn .tit {
    display: inline-block;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    // float: right;
    margin-left: 18px;
  }
}
.zu {
  position: relative;
  .marker {
    width: 14px;
    height: 14px;
    border: 1px solid #d2d6df;
    border-radius: 50%;
    opacity: 0.5;
  }
  .square {
    width: 14px;
    height: 14px;
    border: 1px solid #d2d6df;
    opacity: 0.5;
  }
  .del {
    // color: #e50065;
    position: absolute;
    top: -11px;
    right: -6px;
  }
}
// .sortable-ghost {
//   background: #000;
//   z-index: 999;
// }
</style>
